import { render, staticRenderFns } from "./LogManagementPanel.vue?vue&type=template&id=bfa21250&scoped=true"
import script from "./LogManagementPanel.vue?vue&type=script&lang=js"
export * from "./LogManagementPanel.vue?vue&type=script&lang=js"
import style0 from "./LogManagementPanel.vue?vue&type=style&index=0&id=bfa21250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa21250",
  null
  
)

export default component.exports